import { useEffect, useRef } from 'react'
import { Track } from '../utils/track'

// Fires the 'scrolledToSignCTA' Convert event the first time the returned ref's element scrolls
// into the viewport. Mirrors universal-ovm-fe's SignCtaTracker (IntersectionObserver based);
// reimplemented here from scratch since old-ovm-fe has no visibility-tracking hook yet.
const useScrolledToSignCta = () => {
  const ref = useRef(null)
  const hasTracked = useRef(false)

  useEffect(() => {
    const node = ref.current
    if (!node || typeof IntersectionObserver === 'undefined') return undefined

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasTracked.current) {
          hasTracked.current = true
          Track.Experiment.Event('scrolledToSignCTA')
          observer.disconnect()
        }
      },
      { threshold: 0.5 },
    )

    observer.observe(node)

    return () => observer.disconnect()
  }, [])

  return ref
}

export default useScrolledToSignCta
